module.exports = __webpack_public_path__ + "img/thumbnail_SunBear_f_normal.765ffa37.png";